import React from "react";
import {terminalService} from "../../jwt/_services/hotel/terminalService";

export const terminalProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await terminalService.getOptions( customFilter );

        return listItems.map((item) => {
            return (
                {
                    id: item?.id,
                    value: item?.number,
                    label: <label>{ item?.number }</label>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}